export default __webpack_public_path__ + "static/media/logo-top.131cf808.png";